import { create } from 'zustand';
import { api } from '@/lib/api';

interface AppSettings {
  coachAiEnabled: boolean;
  sessionModeGlobal: boolean;
}

interface SettingsState {
  coachAiEnabled: boolean;
  sessionModeGlobal: boolean;
  loaded: boolean;

  fetchPublicSettings: () => Promise<void>;
  fetchAdminSettings: () => Promise<AppSettings>;
  updateSettings: (updates: Partial<AppSettings>) => Promise<void>;
}

export const useSettingsStore = create<SettingsState>((set) => ({
  coachAiEnabled: false,
  sessionModeGlobal: false,
  loaded: false,

  fetchPublicSettings: async () => {
    try {
      const res = await api.get<{ coachAiEnabled: boolean; sessionModeGlobal: boolean }>(
        '/settings/public',
      );
      set({ coachAiEnabled: res.coachAiEnabled, sessionModeGlobal: res.sessionModeGlobal, loaded: true });
    } catch {
      set({ loaded: true });
    }
  },

  fetchAdminSettings: async () => {
    const res = await api.get<{ settings: AppSettings }>('/admin/settings');
    set({ coachAiEnabled: res.settings.coachAiEnabled, sessionModeGlobal: res.settings.sessionModeGlobal });
    return res.settings;
  },

  updateSettings: async (updates) => {
    const res = await api.put<{ settings: AppSettings }>('/admin/settings', updates);
    set({ coachAiEnabled: res.settings.coachAiEnabled, sessionModeGlobal: res.settings.sessionModeGlobal });
  },
}));
